import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import ReadOnlyListPanel from "../../components/ReadOnlyListPanel";
import { getPublicListings } from "../../api/classicSiteHoodieApi";
import { CLASSIC_SITE_BASE } from "../../classicSite.constants";

export default function PublicListingsPage() {
  const load = useCallback(() => getPublicListings({ limit: 50 }), []);

  return (
    <ReadOnlyListPanel
      title="Public listings (hoodie API)"
      load={load}
      render={(data) => {
        const rows = data.results || data;
        return (
          <table className="cs-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Business</th>
                <th>Short description</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.id}</td>
                  <td>{row.business_name}</td>
                  <td>{row.short_description || "—"}</td>
                  <td>
                    <Link to={`${CLASSIC_SITE_BASE}/public/listings/${row.id}`}>
                      View
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      }}
    />
  );
}
